import { hasText } from 'shared/lib/common-util'
import { PreviousDocument } from '../common/types'
import { RuleResult } from '../../../types/DeclarationP5'

const NA61Validator = {
  validatePreviousDocumentRefNumberRequirement: (previousDocument?: PreviousDocument): RuleResult => {
    if (!previousDocument) return 'OPTIONAL'

    if (hasText(previousDocument.documentType)) {
      return 'REQUIRED'
    }
    if (hasText(previousDocument.procedureType) && previousDocument.procedureType !== 'PIIR') {
      return 'REQUIRED'
    }

    return 'OPTIONAL'
  },
} as const

export default NA61Validator
